var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 63,
    viewBox: "0 0 75 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.4202 43.9427L37.5124 31.0349L24.6045 43.9427",
    stroke: "#1B74BC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5127 31.0349V60.0776",
    stroke: "#1B74BC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5881 51.6551C67.7355 49.9392 70.2219 47.2241 71.6548 43.9382C73.0877 40.6523 73.3855 36.9828 72.5013 33.5089C71.6171 30.0349 69.6012 26.9543 66.7717 24.7533C63.9422 22.5523 60.4604 21.3562 56.8757 21.3539H52.8097C51.8329 17.5759 50.0124 14.0685 47.485 11.0953C44.9576 8.12218 41.7891 5.76068 38.2176 4.18837C34.6462 2.61605 30.7648 1.87383 26.8652 2.01751C22.9657 2.16118 19.1494 3.18702 15.7033 5.01789C12.2573 6.84876 9.27114 9.43702 6.96938 12.5881C4.66762 15.7391 3.11015 19.371 2.41406 23.2107C1.71797 27.0503 1.90137 30.9978 2.95049 34.7563C3.9996 38.5149 5.88712 41.9867 8.47114 44.9107",
    stroke: "#1B74BC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4202 43.9427L37.5124 31.0349L24.6045 43.9427",
    stroke: "#1B74BC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImg);
export default __webpack_public_path__ + "static/media/upload_img.2a0c93d8e130c0f42811f369d5ad17a8.svg";
export { ForwardRef as ReactComponent };